import { Button, Paper, styled } from "@mui/material";

import { useTranslation } from "react-i18next";

import { NavLink } from "components/navigation/NavLink";

interface Props {
  uuid: string;
}

export function ClimateEffectsFooter(props: Props) {
  const { uuid } = props;
  const { t } = useTranslation();
  return (
    <StyledPaper elevation={0}>
      <Button variant="back-button" component={NavLink} to={`/${uuid}`}>
        {t("label.backToProjectArea")}
      </Button>
      <Button
        component={NavLink}
        variant="green-contained"
        to={`/${uuid}/measures`}
      >
        {t("label.measures")}
      </Button>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
`;
